import { useEffect, useState, useContext } from 'react';
import { ThemeContext } from '@emotion/react';
import { navigate } from '@reach/router';
import { AppTheme } from 'theme';

import { GameDifficulty, GameTypeEnum } from 'graphql/types';
import { ProtectedRouteComponentProps } from 'pages/ProtectedRoute';

import Lobby from '../components/Lobby';
import LobbyDifficulty from '../components/LobbyDifficulty';
import LobbyNavigation from '../components/LobbyNavigation';
import MatchView from '../components/MatchView/MatchView';

import useSetGameDifficulty from '../hooks/useSetGameDifficulty';

const Tournament = ({ user, isMediumGameActive }: ProtectedRouteComponentProps) => {
  const theme = useContext(ThemeContext) as AppTheme;

  const IS_EDU = theme?.layout?.edu;

  if (IS_EDU) {
    navigate('/');
  }

  const [processingGameDifficulty, setProcessingGameDifficulty] =
    useState(false);

  const [setGameDifficulty] = useSetGameDifficulty({
    onCompleted: () => {
      setProcessingGameDifficulty(false);
    },
  });

  useEffect(() => {
    if (user.gameDifficulty === GameDifficulty.EASY) {
      setProcessingGameDifficulty(true);
      setGameDifficulty({
        variables: { input: { gameDifficulty: GameDifficulty.MEDIUM } },
      });
    }
  }, [user, setGameDifficulty, setProcessingGameDifficulty]);

  if (!processingGameDifficulty) {
    return (
      <Lobby user={user}>
        <LobbyDifficulty
          state={user.gameDifficulty}
          skipPreview={user.skipPreview}
          isMediumGameActive={isMediumGameActive}
        />
        <LobbyNavigation state="tournament" difficulty={user.gameDifficulty} />
        <MatchView
          gameType={GameTypeEnum.TOURNAMENT_GAME}
          gameDifficulty={user.gameDifficulty}
          isMediumGameActive={isMediumGameActive}
          gamesConfig={user?.company?.gamesConfig}
        />
      </Lobby>
    );
  } else {
    return <div></div>;
  }
};
export default Tournament;
